package com.exura.features.legacyplans.data.repository

import com.exura.features.firebase.data.repository.BaseFirestoreRepository
import com.exura.features.legacyplans.data.mappers.DetailedPlanMappers
import com.exura.features.legacyplans.data.remote.dto.DetailedPlanDto
import com.exura.features.legacyplans.data.serialization.detailedPlanSerializersModule
import com.exura.features.legacyplans.domain.model.DetailedPlan
import com.exura.features.legacyplans.domain.repository.BaseDetailedPlanRepository
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.FirebaseFirestore

class BaseDetailedPlanRepositoryImpl(
    firestore: FirebaseFirestore,
) : BaseDetailedPlanRepository, BaseFirestoreRepository<DetailedPlan, DetailedPlanDto>(
    firestore = firestore,
    mapper = DetailedPlanMappers(),
    dtoSerializersModule = detailedPlanSerializersModule,
) {
    override suspend fun getDto(doc: DocumentSnapshot): DetailedPlanDto =
        doc.data { serializersModule = dtoSerializersModule }

    override suspend fun setDto(dto: DetailedPlanDto, dest: DocumentReference): DocumentReference {
        dest.set(dto) { serializersModule = dtoSerializersModule }
        return dest
    }

    override suspend fun addDto(dto: DetailedPlanDto, dest: CollectionReference): DocumentReference =
        dest.add(dto) { serializersModule = dtoSerializersModule }
}
